<template>
  <div class="components_warp">
    <div class="top-container">
          <div v-for="(topic, index) in topics" :key="index">
            <div v-if="index == curIndex">
              <div class="top-content">
                <div class="img-box">
                  <img :src="topic.img" alt="" />
                </div>
                <!-- <div class="rbga" v-show="isBox">
                    <img v-if="isImg" src="../../../../../public/imgs/careerEvaluation/correct.png" alt="正确">
                    <img v-else src="../../../../../public/imgs/careerEvaluation/error.png" alt="错误">
                </div> -->
                <p>标准图</p>
              </div>
              <div class="radio-list">
                <section class="light">
                  <ul>
                    <li v-for="(t, index) in topic.options" :key="index">
                      <div style="width: 113px; height: 140px">
                        <img :src="t.optImg" alt="" />
                      </div>
                      <label>
                        <input
                          class="radio_btn"
                          type="checkbox"
                          name="light"
                          v-model="radioVal"
                          :value="t.optOrder"
                        />
                        <span class="design"></span>
                        <span class="text"></span>
                      </label>
                    </li>
                  </ul>
                </section>
              </div>
            </div>
          </div>
        </div>
        <div class="btn_warp" v-if="name == 'test'">
          <p :style="{color:color,width:'81px',whiteSpace:'nowrap'}">{{content}}</p>
          <!-- <button><router-link to="/yuyanbiaodadati">确定</router-link></button> -->
          <span></span>
          <button @click="next2" style="position: relative;left:-40px">{{text}}</button>
          <span
            ><em>{{ curIndex + 1 }}</em
            >/{{ topics.length }}</span
          >
        </div>
        <div class="btn_warp" v-else>
          <!-- <button><router-link to="/yuyanbiaodadati">确定</router-link></button> -->
          <span></span>
          <button @click="next">确定</button>
          <span
            ><em>{{ curIndex + 1 }}</em
            >/{{ topics.length }}</span
          >
        </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      startTime:'',
      endTime:'',
      tempTime:'',
      curTempTime:'',
      curIndex: 0,
      topics: [],
      answers: [], //外层
      answer: [], //内层
      radioVal: [],
      radioVal2:['A','C'],
      isBox:false,
      isImg:true,
      name: this.$route.query.name,
      letterArr: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
      url2:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp61'}},
      url:{path:'/careerevalution/home',query: { name:'znsp',part:'znsp71'}},
      text:'确定',
      content:'',
      color:''
    };
  },
  created() {
    //this.getTopicApi();
  },
  mounted(){
    this.startTime = new Date().getTime()

    if(this.name == "test"){
      this.getTopicSplice()
      sessionStorage.setItem("kongTest61",1)
    }else{
      this.getTopicApi()
    }
  },
  methods: {
    getTopicApi() {
      this.$ajax
        .post(
          `${this.G_capi}${this.ports.careerEvaluation.znsp.kjnlList4}`,
          {},
          {
            headers: {
              token: sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.topics = res.data.data;
          console.log(this.topics);
        });
    },
    getTopicSplice(){
      this.topics = [{
                    created_at: 1511479762661,
                    id: "04ad31ba08f54fe681ecd875cc4d2274",
                    img: "./ceping/biao/0.png",
                    name: "表象试题19",
                    options: [
                        {
                            id: "12ea52d4b81d4136a0d0b0cd6619e3e0",
                            optImg: "./ceping/biao/0-A.png",
                            optOrder: "A",
                        },
                        {
                            id: "12ea52d4b81d4136a0d0b0cd6619e3e0",
                            optImg: "./ceping/biao/0-B.png",
                            optOrder: "B",
                        },
                        {
                            id: "12ea52d4b81d4136a0d0b0cd6619e3e0",
                            optImg: "./ceping/biao/0-C.png",
                            optOrder: "C",
                        },
                        {
                            id: "12ea52d4b81d4136a0d0b0cd6619e3e0",
                            optImg: "./ceping/biao/0-D.png",
                            optOrder: "D",
                        }
                    ]
                }]
    },
    next2(){
      if(this.content){
        this.$router.go(-1)
        return
      }
      if (this.radioVal.length <=1||this.radioVal.length>2) {
        this.$message.error("请选择两个答案");
        return false;
      }
    //  this.isBox = true
      if(this.radioVal2.sort().toString() == this.radioVal.sort().toString()){
          this.content='作答正确！'
          this.color='#67C23A'
         // this.isImg = true
      }else{
        this.content='作答错误，正确答案是A、C'
        this.text='返回'
        this.color='red'
        // this.radioVal = ["A","C"]
        //  this.isImg = false
      }
      // setTimeout(function(){
      //    this.$router.push({
      //       path: "/careerevalution/success",
      //       query: {
      //           type: "test",
      //           url:this.url2,
      //     },
      //   });
      // })
    },
    next() {
      if (this.radioVal.length <=1||this.radioVal.length >2) {
        this.$message.error("请选择两个答案");
        return false;
      }
      this.curTempTime = new Date().getTime();
      this.radioVal = this.radioVal.sort();
      for (var i = 0; i < this.radioVal.length; i++) {
        if (this.radioVal[i] == 1) {
          this.answer.push("A");
        } else if (this.radioVal[i] == 2) {
          this.answer.push("B");
        } else if (this.radioVal[i] == 3) {
          this.answer.push("C");
        } else if (this.radioVal[i] == 4) {
          this.answer.push("D");
        }
      }
      this.answers.push({
        questionId: this.topics[this.curIndex].id,
        answer: this.answer,
      });
      this.radioVal = [];
      if (this.curIndex + 1 < this.topics.length) {
        this.answer = [];
        this.curIndex++;
      } else {
        this.saveNode(2,71,()=>{
          this.submit()
        })
        
      }
    },
    submit() {
      //提交
      this.endTime = new Date().getTime();//结束时间
      this.tempTime = Number(this.endTime) - Number(this.startTime);
      this.$ajax
        .post(
          `${this.G_capi}${this.ports.careerEvaluation.znsp.kjnlAdd4}`,
          {
            testId: sessionStorage.getItem("testId"),
            time: this.tempTime,
            answers: this.answers,
          },
          {
            headers: {
              token: sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          var data = res.data;
          if(data.code==2000){
            this.$router.push({
              path: "/careerevalution/success",
              query: {
                type: "answer",
                url:this.url,
              },
            });
          }
        });
    },
  },
};
</script>

<style scoped>
.components_warp{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.btn_warp {
  display: flex;
  justify-content: space-between;
}
/* 按钮 */
.btn_warp button {
  width: 166px;
  height: 41px;
  background: linear-gradient(90deg, #1fd99c 0%, #1ac6fd 100%);
  border-radius: 21px;
  border: none;
  color: #fff;
  font-size: 18px;
  margin: 40px auto 0;
  display: block;
}

.btn_warp em {
  font-style: normal;
  color: red;
}
.btn_warp span {
    font-size: 18px;
  /* position: relative;
    right: -250px; */
  display: block;
  flex: 1;
  text-align: right;
  margin-top: 40px;
  line-height: 41px;
}
.rbga{
  width: 125px;
  height: 150px;
  opacity: 0.6;
    background: #000;
    position: absolute;
    top: 0;
}
.top-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
}
.img-box {
  width: 125px;
  height: 150px;
}
img {
  height: 100%;
  width: 100%;
}
.img-box p {
  text-align: center;
}

/* 单选按钮 */

.light {
  --primary: #29d3ec;
  --other: #29d3ec;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.light ul {
  display: flex;
}
.light ul li {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.dark {
  --primary: hsl(1, 100%, 68%);
  --other: hsl(0, 0%, 90%);
  background: hsl(0, 0%, 10%);
}

/* h1 */
h1 {
  color: var(--other);
  padding: 8px 4px;
  border-bottom: 2px solid var(--other);
}

/* label */
label {
  width: 200px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column-reverse;
  flex-wrap: nowrap;
  margin: 12px 0;
  cursor: pointer;
  position: relative;
  border-radius: 8px;
}

/* input */
.radio_btn {
  opacity: 0;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: -1;
}

/* .design */
.design {
  width: 16px;
  height: 16px;
  border: 1px solid var(--other);
  /* border-radius: 100%; */
  /* margin-right: 16px; */
  position: relative;
  top: 15px;
}
.design em {
  display: inline-block;
  position: absolute;
  left: 30px;
  top: -1px;
  font-style: normal;
  vertical-align: middle;
}

.design::before,
.design::after {
  content: "";
  display: block;
  width: inherit;
  height: inherit;
  border-radius: inherit;
  position: absolute;
  -webkit-transform: scale(0);
  transform: scale(0);
  -webkit-transform-origin: center center;
  transform-origin: center center;
}

.design:before {
  background: var(--other);
  opacity: 0;
  transition: 0.3s;
}

.design::after {
  background: var(--primary);
  opacity: 0.4;
  transition: 0.6s;
}

/* .text */
.text {
  /* font-weight: bold; */
}

/* checked state */
.radio_btn:checked + .design::before {
  opacity: 1;
  -webkit-transform: scale(0.6);
  transform: scale(0.6);
}
</style>